

































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

@Component
export default class ProductDropdown extends Vue {
  @Prop() readonly productList!: [];

  @Prop() readonly type!: string;

  @Prop() readonly itemSelected!: any;

  @Prop() readonly handleProductDropdown!: Function;
}
